module.exports = __webpack_public_path__ + "img/pants_length.3b4878d9.png";